import Kalender from "../../../../../components/categories/siakad/lms/data_kalender/Home";
export default function Home() {
  
  return (
    <Kalender />
  );
}
